import { DROPDOWN_TAGS } from "../../../../consts/tags.consts"
import apiService from "../../../../services/api.service"

export const getFormOptions = (method: string, body: any = {}) => {
    return async (dispatch: any) => {
        const res = await dispatch(apiService.endpoints.get.initiate({
            method,
            body: body,
            providesTags: [DROPDOWN_TAGS.LIST]

        }))

        return res;
    }
}